import { gql } from '@zenbusiness/application-commons-graphql';

export const REQUEST_BANKING_PRODUCT_OFFER_MUTATION = gql`
  mutation RequestBankOfAmericaOffer($businessEntityUuid: UUID!) {
    requestBankOfAmericaOffer(businessEntityUuid: $businessEntityUuid)
  }
`;
